import * as filters from './index.js'

export default function registerGlobalFilters(Vue) {
  Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key])
  })
}
